import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate
} from 'react-router-dom';
import * as Sentry from '@sentry/react';

import LoginPage from '@/app/login/Page';
import CoachListPage from '@/app/coach/ListPage';
import Dashboard from '@/app/dashboard/Page';
import SettingList from '@/app/setting/List';
import SelectTenant from '@/app/tenant/Select';
import AccountList from '@/app/setting/accounts/AccountList';
import GeneralView from '@/app/setting/general/GeneralView';
import ActivateUser from '@/app/activate/Activate';
import ActivateTenantUser from '@/app/activate/ActivateTenantUser';
import LocationListPage from '@/app/location/ListPage';
import LocationAddPage from '@/app/location/AddPage';
import LocationEditPage from '@/app/location/EditPage';
import CoachViewPage from '@/app/coach/ViewPage';
import CoachActivitiesNavigation from '@/app/coachActivity/Navigation';
import CoachActivitiesTab from '@/app/coachActivity/Tab';

import ErrorFallback from './ErrorFallback';

import './index.css';
import App from './App.jsx';

console.log(import.meta.env.PROD);
// eslint-disable-next-line no-undef
if (process.env.VITE_NODE_ENV === 'production') {
  console.log('Initializing Sentry');
  Sentry.init({
    dsn: 'https://0e4311976d17a2647af1ff03797fe2ec@o4508229293703168.ingest.us.sentry.io/4508255155191808',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    // Tracing
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api.profoundpros\.com\/v1/
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Capture all errors
    sampleRate: 1.0,
    // Enable source maps
    enableTracing: true
  });
}

const router = createBrowserRouter([
  { path: '/login', element: <LoginPage />, errorElement: <ErrorFallback /> },
  {
    path: '/tenant',
    element: <SelectTenant />,
    errorElement: <ErrorFallback />
  },
  {
    path: '/activate/:activationId/tenant-user/:tenantUserActivationId',
    element: <ActivateUser />,
    errorElement: <ErrorFallback />
  },
  {
    path: '/activate-tenant-user/:tenantUserActivationId',
    element: <ActivateTenantUser />,
    errorElement: <ErrorFallback />
  },
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorFallback />,
    children: [
      {
        index: true,
        element: <Dashboard />
      },
      {
        path: 'coach',
        children: [
          {
            index: true,
            element: <CoachListPage />
          },
          {
            path: ':id',
            element: <CoachViewPage />,
            children: [
              {
                index: true,
                element: <Navigate to="activities" />
              },
              {
                path: 'activities',
                element: <CoachActivitiesNavigation />,
                children: [
                  {
                    path: ':coachActivityId',
                    element: <CoachActivitiesTab />
                  }
                ]
              }
              //     {
              //       path: 'tenants',
              //       element: <CoachViewTenantsTab />
              //     },
              //     {
              //       path: 'bookings',
              // element: <CoachViewBookingsTab />
            ]
          }
        ]
      },
      {
        path: 'setting',
        children: [
          {
            index: true,
            element: <SettingList />
          },
          {
            path: 'general',
            element: <GeneralView />
          },
          {
            path: 'accounts',
            element: <AccountList />
          }
        ]
      },
      {
        path: 'location',
        children: [
          {
            index: true,
            element: <LocationListPage />
          },
          {
            path: 'add',
            element: <LocationAddPage />
          },
          {
            path: ':id',
            element: <LocationEditPage />
          }
        ]
      }
    ]
  }
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
